import * as Yup from "yup";

export const DETAIL_TYPE = {
  PARAGRAPH: "paragraph",
  LINK_ATTACHED: "linkAttached",
};

export const policyCategoryInitialValues = {
  policyCategoryName: null,
  statusFlag: '',
};

export const policyCategorySchema = Yup.object().shape({
  policyCategoryName: Yup.string().required("Please enter."),
});

export const policyInitialValues = {
  policyName: null,
  policyCategoryId: null,
  detailType: DETAIL_TYPE.PARAGRAPH,
  statusFlag: '',
};

const policySchema = Yup.object().shape({
  policyName: Yup.string().required("Please enter."),
  policyCategoryId: Yup.string().required("Please select."),
});

export default policySchema;
